import Styles from './ProcessingMedia.module.scss'
import { isVideo } from 'components/ImagePickerModal/utils'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import { ProcessingMediaProps, ProcessingState } from '../Types'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

export const ProcessingMedia = ({ selectedMedia, processingState }: ProcessingMediaProps) => {
  const label = (() => {
    const fileType = isVideo({ url: selectedMedia.source_url, type: selectedMedia.mime_type }) ? 'video' : 'image'
    if (processingState === ProcessingState.Downloading) return `Grabbing your ${fileType}`
    if (processingState === ProcessingState.Uploading) return `Uploading ${fileType}`
    if (processingState === ProcessingState.RemovingBackground) return `Removing background`
    return undefined
  })()

  const isProcessing = processingState !== ProcessingState.Complete && !!processingState

  return (
    <div className={Styles.content}>
      <LoadingShimmerer show={isProcessing}>
        <img
          src={selectedMedia.thumbnail_url || selectedMedia.source_url}
          alt="Selected media"
          className={Styles.mediaPreview}
        />
      </LoadingShimmerer>
      {label && (
        <span className={Styles.processingLabel}>
          {label}
          <LoadingEllipses />
        </span>
      )}
    </div>
  )
}
